import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { openModal } from '@/store';
import { useAppDispatch, useAppSelector } from './redux';

/**
 * Referral links are shared as `?mode=register&refCode=...`. On first load:
 * - If the visitor isn't already logged in, this opens the register modal so
 *   the referral code (picked up separately by useRegister via the same query
 *   string) is pre-filled without any extra action from the visitor.
 * - If the visitor is already logged in, the params are irrelevant, so they're
 *   stripped from the URL instead of leaving a dead `?mode=register&refCode=...`
 *   in the address bar.
 */
export function useReferralRegisterModal() {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (searchParams.get('mode') !== 'register') return;

    if (isAuthenticated) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('mode');
      nextParams.delete('refCode');
      setSearchParams(nextParams, { replace: true });
    } else {
      dispatch(openModal({ name: 'register' }));
    }
    // Only ever check once, on initial load.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
